import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["as", "code", "className"];
import React, { useState } from 'react';
import copy from 'copy-to-clipboard';
import classNames from 'classnames';
import CopyIcon from './icons/Copy';
import CheckIcon from './icons/Check';
import { jsx as _jsx } from "react/jsx-runtime";
function CopyCodeButton(props) {
  var _props$as = props.as,
    Component = _props$as === void 0 ? 'button' : _props$as,
    code = props.code,
    className = props.className,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var _useState = useState(false),
    copied = _useState[0],
    setCopied = _useState[1];
  if (!code) {
    return null;
  }
  var handleClick = function handleClick() {
    setCopied(true);
    copy(code);
    setTimeout(function () {
      setCopied(false);
    }, 2000);
  };
  return /*#__PURE__*/_jsx(Component, _extends({}, rest, {
    className: classNames('copy-code-button', className),
    onClick: handleClick,
    children: copied ? /*#__PURE__*/_jsx(CheckIcon, {}) : /*#__PURE__*/_jsx(CopyIcon, {})
  }));
}
export default CopyCodeButton;